import { Box } from 'shared';
import styled, { from, to } from 'theme';

export const SidebarWrapper = styled(Box)`
  background-color: ${props => props.theme.variables.customColors.sidebarBackgroundColor};
  padding: 1rem;

  ${to('md')} {
    .sidebar__sub-menu,
    .sidebar__menu-item,
    .collapse {
      display: none;
    }

    margin-bottom: 0;
  }

  ${from('md')} {
    height: 100%;
    padding: 2.5rem 1.5rem 1rem 2rem;

    > *:not(:last-child) {
      margin-bottom: 1.5rem;
    }
  }

  ${from('lg')} {
    padding: 2.5rem 3.5rem 1rem 3.5rem;
  }

  ${from('xlg')} {
    padding: 4.5rem 3.5rem 2rem 3.5rem;
  }
`;

export const SidebarMenuItem = styled.span<{ active?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 1.125rem;
  color: ${props => props.theme.variables.customColors.textColor};
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  line-height: 1.3;
  font-weight: ${props =>
    props.active ? props.theme.variables.fonts.weight.bold : props.theme.variables.fonts.weight.medium};
  font-size: 0.9rem;

  img {
    margin-right: 0.75rem;
  }

  &:hover {
    color: ${props => props.theme.variables.customColors.leadingColor.base};
  }

  .collapse-icon {
    margin-left: 0.75rem;
    transition: all 0.4s;
    transform: rotate(0deg);

    &.collapse-icon--collapsed {
      transform: rotate(180deg);
    }
  }
`;

export const SidebarSubmenu = styled.div`
  border-left: 0.0625rem solid ${props => props.theme.variables.customColors.lightNavy};
  margin-left: 1rem;
  margin-top: 1rem;
  padding: 1rem;
  width: 100%;

  ${from('lg')} {
    margin-left: 2rem;
  }
`;

export const SidebarSubmenuItem = styled.span<{ active?: boolean }>`
  display: flex;
  align-items: center;
  color: ${props =>
    props.active ? props.theme.variables.customColors.lightNavy : props.theme.variables.customColors.grayMedium};
  font-size: 0.9rem;

  img {
    margin-left: 0.75rem;
  }

  &:hover {
    color: ${props => props.theme.variables.customColors.lightNavy};
  }

  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;
